<template>
  <div class="section-category section-full pay-commission-table">
    <div class="inner-pay-commission">
      <h2 class="ttl2 popup-header" v-translate>Pay Commission</h2>
      <div class="btn-report-commission">
        <button type="button" @click="printCommissions" class="btn btn-primary px-4" v-translate>Commission Report</button>
      </div>
      <table class="table table-commission">
        <thead>
          <tr>
            <th v-translate>ID Staff</th>
            <th v-translate>Name</th>
            <th v-translate :colspan="2">Commission</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in commissions" :key="index" >
            <td>{{ item.ref }}</td>
            <td>{{ item.firstName }} {{ item.lastName }}</td>
            <td :colspan="2">{{ item.amount | currency }}
            </td>
            <td><button type="button" class="btn btn-primary px-4" @click="onPay(item)" v-translate>Pay</button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { SET_MESSAGE_MODAL, SET_CONFIRM_MODAL } from '@/store/mutation-types';
import CommissionService from '@/services/CommissionService';
import {mapState} from "vuex";
export default {
  name: 'PayCommission',
  data() {
    return {
      interval: null,
    };
  },
  destroyed() {
    clearInterval(this.interval);
  },
  computed: {
    ...mapState({
      workDay: state => state.auth.user.workDay,
      user: state => state.auth.user,
    }),
    commissions() {
      return this.$store.state.commission.amountCommissions;
    },
  },
  created() {
    this.$store.dispatch('getCommission');
    return this.getCommissionList();
  },
  methods: {
    async printCommissions() {
      const data = await CommissionService.printReportCommissions();
      if (data && !data.error) {
        await this.$store.dispatch('print', {billData: data, printProductTicket: false});
      } else {
        this.$store.commit(SET_MESSAGE_MODAL, data);
      }
    },
    getCommissionList() {
      const self = this;
      this.interval = setInterval(() => self.$store.dispatch('getCommission'), 5000);
    },
    onPay(staff) {
      this.$store.commit(SET_CONFIRM_MODAL, {
        action: this.$gettext('pay') + ' ' 
                 + staff.firstName + ' ' + staff.lastName 
                 + ' (staff #' + staff.ref + ') ' 
                 + this.$options.filters.currency(staff.amount),
        context: this,
        func: this.payCommission,
        args: [staff],
        noCloseOnLoaded: true
      });
    },
    async payCommission(staff) {
      const res = await CommissionService.payCommission(staff);
      if (res) {
        await this.$store.dispatch('print', { billData: res, printProductTicket: false });
      }
      this.$store.commit('removeCommission', staff);
      this.$store.commit(SET_CONFIRM_MODAL, null);
    },
  },
};
</script>
<style lang="css">
  .btn-report-commission {
    position: absolute;
    top: 12px;
    right: 12px;
  }
</style>
